<template>
	<Loading :loading="renosLoading || wpContentLoaded" class="container">
		<WordpressContentPage
			:pageSlug="pageSlug"
			class="col-12"
			:showLoading="false"
			@loaded="() => {wpContentLoaded = false}"
		/>
		<div v-if="loggedIn">
			<RenovationsTable v-for="(data, index) of renos" :key="index" :tableData="data"/>
		</div>
	</Loading>
</template>

<script>

import { renos } from "@/network/renoRequests";
import Loading from "@/components/loading/Loading";
import WordpressContentPage from "@/wordpress/WordpressContentPage";
import RenovationsTable from "./RenovationsTable";
import { mapState } from "vuex";

export default {
	name: 'Renovations',
	props: ["pageSlug"],
	data() {
		return {
			renos: null,
			renosLoading: true,
			wpContentLoaded: true,
		}
	},
	created(){
		this.renos = renos;
		this.renosLoading = false;
	},
	components: {
		Loading,
		WordpressContentPage,
		RenovationsTable,
	},
	computed: {
		...mapState({
			loggedIn: state => state.auth.loggedIn
		})
	}
}
</script>

<style lang="scss" scoped>

</style>
